// extracted by mini-css-extract-plugin
export default {"loading":"pdf-action_loading__fZHon","spin":"pdf-action_spin__S+4+C"};